// シンプルなルーティング実装
export class Router {
  constructor() {
    this.routes = {};
    this.currentRoute = null;
    
    // ブラウザの戻る/進むボタン対応
    window.addEventListener('popstate', () => {
      this.navigate(window.location.pathname, false);
    });
    
    // リンククリックをインターセプト
    document.addEventListener('click', (e) => {
      const link = e.target.closest('a');
      if (link && link.href && link.href.startsWith(window.location.origin)) {
        const href = link.getAttribute('href');
        // .htmlファイル、mailtoリンク、ハッシュリンクは通常のナビゲーションを許可
        if (href && (href.endsWith('.html') || href.startsWith('mailto:') || href.startsWith('#'))) {
          return;
        }
        e.preventDefault();
        this.navigate(href);
      }
    });
  }
  
  // ルート登録
  on(path, callback) {
    this.routes[path] = callback;
  }
  
  // ページ遷移
  navigate(path, pushState = true) {
    // トレーリングスラッシュを除去（ルートパス以外）
    if (path !== '/' && path.endsWith('/')) {
      path = path.slice(0, -1);
    }

    if (pushState) {
      window.history.pushState({}, '', path);
    }

    // パス解析（パラメータ対応）
    let handler = null;
    let params = {};
    
    for (const [routePath, callback] of Object.entries(this.routes)) {
      const regex = new RegExp('^' + routePath.replace(/:(\w+)/g, '([^/]+)') + '$');
      const match = path.match(regex);
      
      if (match) {
        handler = callback;
        const paramNames = [...routePath.matchAll(/:(\w+)/g)].map(m => m[1]);
        match.slice(1).forEach((value, index) => {
          params[paramNames[index]] = value;
        });
        break;
      }
    }
    
    if (handler) {
      this.currentRoute = path;
      handler(params);
    } else {
      // 404処理 - 無限ループを防ぐ
      if (this.routes['/404'] && path !== '/404') {
        this.currentRoute = '/404';
        this.routes['/404']({});
      } else if (path !== '/') {
        this.navigate('/');
      } else {
        // ホームページも404もない場合は、基本的なエラーメッセージを表示
        document.getElementById('app').innerHTML = '<div style="text-align:center;padding:50px;"><h1>404 - ページが見つかりません</h1></div>';
      }
    }
  }
  
  // 初期化
  init() {
    this.navigate(window.location.pathname, false);
  }
}